export default __webpack_public_path__ + "static/media/intro-video.746cb21b.mp4";